import {
  AppAvatar,
  AppBox,
  AppDivider,
  AppIconButton,
  AppLink,
  AppPaper,
  AppText,
  AppTitle,
} from "../../../../../commons/components";
import IconEdit from "../../../../../commons/components/icons/edit";
import IconPersonDelete from "../../../../../commons/components/icons/person-delete";
import AppLineUpBadge from "../../../../../commons/components/ui-components/LineupBadge";
import { IFootballTeamPlayer } from "../../../../../commons/models/football/interface/i-football-team-player";
import { toSentenceCase, toTitleCase } from "../../../../../commons/utilities/string-utils";
import ability, { Can } from "../../../../../casl/Can";
import { useAppSelector } from "../../../../../hooks/app";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { ManageFootballPlayer } from "../../../../../commons/models/football/admin/manage-football-player";

interface PlayerCardProps {
  playerInfo: IFootballTeamPlayer;
  onPlayerRemove: (player: IFootballTeamPlayer) => void;
  onPlayerEdit: (player: IFootballTeamPlayer) => void;
}

export default function TeamPlayerCard({ playerInfo, onPlayerRemove, onPlayerEdit }: PlayerCardProps) {
  const playerPath = `/manage/players/${playerInfo.player.id}`;
  const { teamInfo } = useAppSelector((state) => state.footballManageTeam);
  const canReadPlayer = ability.can(
    RolePolicyActionEnum.READ,
    new ManageFootballPlayer().create(playerInfo?.player) as ManageFootballPlayer
  );
  const handleLinkClick = (e: MouseEvent) => {
    if (!canReadPlayer) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <AppPaper padding="xs" shadow="xs">
      <AppBox justifyContent="space-between" alignItems="center">
        <AppLink onClick={handleLinkClick} style={{ pointerEvents: canReadPlayer ? "auto" : "none" }} to={playerPath}>
          <AppBox gap="xs" alignItems="center">
            <AppAvatar username={playerInfo.player?.fullName || ""} src={playerInfo.player?.avatar || ""} size="lg" />
            <AppBox flexDirection="column">
              <AppBox alignItems="center" gap="2xs">
                <AppTitle as="h6">{toTitleCase(playerInfo.player?.displayName)}</AppTitle>
                {playerInfo.isCaptain && <AppLineUpBadge status="CAPTAIN" size={20} />}
              </AppBox>
              <AppBox>
                <AppText as="span" fontWeight="semibold" size="sm" color="muted">
                  {playerInfo.jerseyNumber}
                </AppText>
                <AppDivider orientation="vertical" mx="3xs" color="dark" />
                <AppText as="span" fontWeight="semibold" size="sm" color="muted">
                  {toSentenceCase(playerInfo.position)}
                </AppText>
              </AppBox>
            </AppBox>
          </AppBox>
        </AppLink>
        <Can I={RolePolicyActionEnum.UPDATE} this={teamInfo}>
          <AppBox gap="xs">
            <AppIconButton
              variant="light"
              onClick={() => {
                onPlayerEdit(playerInfo);
              }}
              icon={<IconEdit />}
            />
            <AppIconButton
              variant="light"
              color="danger"
              onClick={() => {
                onPlayerRemove?.(playerInfo);
              }}
              icon={<IconPersonDelete />}
            />
          </AppBox>
        </Can>
      </AppBox>
    </AppPaper>
  );
}
